type ResizeOptions = {
  width?: number;
  height?: number;
  withoutEnlargement?: boolean;
};

const RESIZE_ENABLED_SERVERS = [
  'storage.prod.alpha-analytics.dev',
  'storage.api.dev.omnetic.dev',
  'storage.api.sandbox.omnetic.dev',
  'storage.api.stage.omnetic.dev',
  'storage.api.omnetic.com',
];

export const makeStorageResizeUrl = (url: string, options: ResizeOptions) => {
  try {
    const originalUrl = new URL(url, window.location.href);

    const isResizeEnabled = RESIZE_ENABLED_SERVERS.includes(originalUrl.hostname);
    const hasResizablePath = url.includes('/get/') || url.includes('/resize/');
    const hasResizeDimensions = options.width || options.height;

    if (!isResizeEnabled || !hasResizablePath || !hasResizeDimensions) {
      return url;
    }

    const resizeUrl = new URL(
      url.includes('/get/') ? url.replace('/get/', '/resize/') : url,
      window.location.href
    );

    if (options.width) {
      resizeUrl.searchParams.set('width', options.width.toString());
    }
    if (options.height) {
      resizeUrl.searchParams.set('height', options.height.toString());
    }
    if (options.withoutEnlargement) {
      resizeUrl.searchParams.set('withoutEnlargement', 'true');
    }

    return resizeUrl.toString();
  } catch {
    return url;
  }
};
